import { SEVERITY_BADGE } from "./config";

export function SeverityBadge({ severity }: { severity: string | null }) {
  const sev = severity ?? "observation";
  const cls = SEVERITY_BADGE[sev] ?? SEVERITY_BADGE["observation"]!;
  return (
    <span className={`inline-block rounded px-1.5 py-0.5 text-[10px] font-bold uppercase whitespace-nowrap ${cls}`}>
      {sev}
    </span>
  );
}
